import { FC, useEffect } from 'react';
import { getQueryParam } from 'lib/util';
import { useFinishRegistrationMutation } from 'lib/home/generated/queries';
import { RegistrationRouteMap } from '../../store';
import { useLogin } from '../../hooks';

const ValidateEmailPage: FC = () => {
  const login = useLogin();
  const redirectPath = RegistrationRouteMap.customizeBox;

  const { mutate } = useFinishRegistrationMutation({
    onSuccess: ({ finishRegistration: { token } }) => {
      login(token, { redirectPath });
    }
  });

  useEffect(() => {
    const token = getQueryParam('token');
    mutate({ token });
  }, []);

  return null;
};

export default ValidateEmailPage;
